import { Validators } from '@angular/forms';
import { EmailRegExp } from 'src/app/order/validators/email-compare-validator';
import { PhoneValidator } from 'src/app/order/validators/phone-validator';

export const customTechnicalContactValidators = {
  name: {
    validators: [Validators.required],
    updateOn: 'blur',
  },
  email: {
    validators: [Validators.required, Validators.maxLength(50), Validators.pattern(EmailRegExp)],
    updateOn: 'blur',
  },
  primaryPhone: {
    validators: [PhoneValidator, Validators.required],
    updateOn: 'blur',
  },
  secondaryPhone: {
    validators: [PhoneValidator],
    updateOn: 'blur',
  },
  mobileNumber: {
    validators: [PhoneValidator, Validators.required],
    updateOn: 'blur',
  },
};
